var set = require('lodash/set');

function setGlobal(path, value){
    set(window, path, value);
}

window.set = setGlobal;
module.exports = setGlobal;
export default setGlobal




// WEBPACK FOOTER //
// ./node_modules/linksoft/src/setGlobal.js